"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const Text_1 = __importDefault(require("./Text"));
const VisibilityIcon_1 = __importDefault(require("../icons/VisibilityIcon"));
const VisibilityOffIcon_1 = __importDefault(require("../icons/VisibilityOffIcon"));
const ButtonBase_1 = __importDefault(require("./ButtonBase"));
const CloseIcon_1 = __importDefault(require("../icons/CloseIcon"));
const TextInput = ({ autoCapitalize, editable = true, iconComponent, label, placeholder, selected, style, textInputStyle, value, helperText, secureTextEntry = false, showClearIconOnBlur, onFocus, onBlur, ...textInputProps }) => {
    const ref = react_1.useRef(null);
    const [isFocused, setIsFocused] = react_1.useState(false);
    const [passVisibility, setpassVisibility] = react_1.useState(secureTextEntry);
    const [shouldShowClearIcon, setShouldShowClearIcon] = react_1.useState(false);
    const isLabelVisible = (isFocused || !!value) && !!label;
    react_1.useEffect(() => {
        if (selected)
            ref.current.focus();
    }, [selected]);
    react_1.useEffect(() => {
        if (react_native_1.Platform.OS === 'web') {
            const timeout = setTimeout(() => {
                setShouldShowClearIcon(!!value && (isFocused || !!showClearIconOnBlur));
            }, 125);
            return () => clearTimeout(timeout);
        }
        else {
            setShouldShowClearIcon(!!value && (isFocused || !!showClearIconOnBlur));
        }
    }, [isFocused, showClearIconOnBlur, value]);
    const handleBlur = (e) => {
        setIsFocused(false);
        if (onBlur)
            onBlur(e);
    };
    const handleFocus = (e) => {
        setIsFocused(true);
        if (onFocus)
            onFocus(e);
    };
    const handleSecureTextVisibilityIcon = () => {
        return passVisibility ? (react_1.default.createElement(ButtonBase_1.default, { onPress: () => {
                setpassVisibility(!passVisibility);
            } },
            react_1.default.createElement(VisibilityIcon_1.default, { style: styles.icon }))) : (react_1.default.createElement(ButtonBase_1.default, { onPress: () => {
                setpassVisibility(!passVisibility);
            } },
            react_1.default.createElement(VisibilityOffIcon_1.default, { style: styles.icon })));
    };
    const onClearPress = () => {
        textInputProps.onChangeText && textInputProps.onChangeText('');
        setShouldShowClearIcon(false);
    };
    const ClearButton = (react_1.default.createElement(ButtonBase_1.default, { onPress: onClearPress },
        react_1.default.createElement(CloseIcon_1.default, { fill: styles_1.Colors.primary, style: react_native_1.StyleSheet.flatten([styles.clearIcon, styles.icon]), height: 20, width: 20 })));
    const handleClearIcon = () => {
        // if (value) {
        //   if (showClearIconOnBlur) return ClearButton;
        //   else if (isFocused) return ClearButton;
        // }
        if (shouldShowClearIcon)
            return ClearButton;
        return null;
    };
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([{ marginBottom: styles_1.getSpacing() }, style]) },
        react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.textInputContainer, !editable && styles.disabledInputContainer]) },
            react_1.default.createElement(Text_1.default, { style: react_native_1.StyleSheet.flatten([styles.label, !isLabelVisible && styles.hidden]), margin: "none" },
                label,
                ":"),
            react_1.default.createElement(react_native_1.TextInput, Object.assign({}, textInputProps, { ref: ref, editable: editable, style: react_native_1.StyleSheet.flatten([
                    styles.textInput,
                    !editable && styles.disabledTextInput,
                    textInputStyle,
                    react_native_1.Platform.select({
                        android: {
                            padding: 0,
                        },
                        web: {
                            outline: 'none',
                        },
                    }),
                ]), secureTextEntry: passVisibility, placeholder: !isFocused ? placeholder : '', placeholderTextColor: styles_1.Colors.darkGray, value: value, autoCapitalize: autoCapitalize, onFocus: handleFocus, onBlur: handleBlur })),
            iconComponent && react_1.default.createElement(react_native_1.View, { style: styles.icon }, iconComponent),
            handleClearIcon(),
            secureTextEntry && handleSecureTextVisibilityIcon()),
        !!helperText && (react_1.default.createElement(Text_1.default, { color: "error", variant: "caption", margin: "none", style: { marginLeft: styles_1.getSpacing(), marginTop: styles_1.getSpacing(0.5) } }, helperText))));
};
exports.default = TextInput;
const styles = react_native_1.StyleSheet.create({
    textInputContainer: {
        backgroundColor: styles_1.Colors.background,
        alignItems: 'center',
        borderRadius: styles_1.getRadius(),
        paddingHorizontal: styles_1.getSpacing(),
        overflow: 'hidden',
        flexDirection: 'row',
        height: styles_1.getSpacing('row'),
    },
    label: {
        color: styles_1.Colors.darkGray,
        paddingEnd: styles_1.getSpacing(),
        ...react_native_1.Platform.select({
            android: {
                paddingEnd: 0,
                paddingStart: styles_1.getSpacing(),
            },
        }),
    },
    hidden: {
        display: 'none',
    },
    textInput: {
        fontFamily: 'IranYekan-FD-Regular',
        color: styles_1.Colors.primary,
        flex: 1,
        fontSize: styles_1.getFontSize(),
        ...react_native_1.Platform.select({
            native: {
                textAlign: 'right',
            },
            web: {
                // direction: 'rtl',
                writingDirection: 'rtl',
            },
        }),
    },
    disabledTextInput: {
        color: styles_1.Colors.black,
    },
    disabledInputContainer: {
        backgroundColor: styles_1.Colors.white,
        borderWidth: styles_1.getSpacing('border'),
        borderColor: styles_1.Colors.border,
    },
    icon: {
        marginLeft: styles_1.getSpacing(0.5),
    },
    clearIcon: {
        marginRight: styles_1.getSpacing(0),
    },
});
